import {FITH2GameConfig} from "../configs/FITH2GameConfig";

export class FITH2WildWinAnimation extends PIXI.Container {

    constructor() {
        super();
        this.name = "FITH2WildWinAnimation";
        this.position = FITH2GameConfig.reelAreaPos;
    }
}